<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  form(v-on:submit.prevent="handleSubmit")

    c-form-error(v-bind:message="$t(responseErrorMessage)")
    .sections-wrapper
      .section.section-left
        // Name
        div.form-group
          input.form-control(type="text" v-model="firstName" v-bind:disabled="isLoading" v-bind:placeholder="$t('input_name')"
          v-bind:class="$v.firstName.$error ? 'is-invalid' :'is-dirty'" v-on:input="$v.firstName.$touch()")
          div.invalid-feedback(v-if="!$v.firstName.required") {{ $t('error_first_name_required') }}

        // Surname
        div.form-group
          input.form-control(type="text" v-model="lastName" v-bind:disabled="isLoading" v-bind:placeholder="$t('input_surname')"
          v-bind:class="$v.lastName.$error ? 'is-invalid' :'is-dirty'" v-on:input="$v.lastName.$touch()")
          div.invalid-feedback(v-if="!$v.lastName.required") {{ $t('error_last_name_required') }}
      
      .section.section-right
        div.form-group

          // Password
          div(v-bind:class="$v.password.$error ? 'is-invalid' :'is-dirty'")
            div.form-group.input-password
              input.form-control(type="password" v-model="password" v-bind:disabled="isLoading" v-bind:placeholder="$t('input_password')"
              v-bind:class="$v.password.$error ? 'is-invalid' :'is-dirty'"
              v-on:input="$v.password.$touch()")
            div.form-group.input-password
              input.form-control(type="password" v-model="repeatPassword" v-bind:disabled="isLoading" v-bind:placeholder="$t('input_repeat_password')"
              v-bind:class="$v.password.$error ? 'is-invalid' :'is-dirty'")

            div.invalid-feedback(v-if="!$v.password.required") {{ $t('error_password_required') }}
            div.invalid-feedback(v-else-if="!$v.password.sameAsPassword") {{ $t('error_password_not_same') }}
            div.invalid-feedback(v-else-if="!$v.password.minLength") {{ $t('error_password_min_length', { min: $v.password.$params.minLength.min }) }}

    div
      c-form-submit(v-bind:isLoading="requestBeingProcessed") {{ $t('btn_sign_in') }}

</template>

<script>
import { minLength, numeric, required, sameAs } from 'vuelidate/lib/validators';

import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import * as types from 'store/mutation-types';

export default {
  mixins: [mFormSubmit],

  components: {
    cFormError,
    cFormSubmit,
  },

  data() {
    return {
      isLoading: false,
      isValidated: false,
      errorMessage: null,
    };
  },

  computed: {
    clientType: {
      get() {
        return this.$store.state.registration.clientType;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_CLIENT_TYPE}`, value);
      },
    },
    firstName: {
      get() {
        return this.$store.state.registration.firstName;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_FIRST_NAME}`, value);
      },
    },
    lastName: {
      get() {
        return this.$store.state.registration.lastName;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_LAST_NAME}`, value);
      },
    },
    password: {
      get() {
        return this.$store.state.registration.password;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_PASSWORD}`, value);
      },
    },
    repeatPassword: {
      get() {
        return this.$store.state.registration.repeatPassword;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REPEAT_PASSWORD}`, value);
      },
    },

    phoneCode() {
      return this.$store.state.registration.phoneCode;
    },
    phoneNumber() {
      return this.$store.state.registration.phoneNumber;
    },

    smsCode() {
      return this.$store.state.registration.smsCode;
    },
    smsCodeValid() {
      return this.$store.state.registration.smsCodeValid;
    },
  },

  validations: {
    // clientType: {
    //   required
    // },
    phoneCode: {
      required,
      numeric,
      minLength: minLength(1),
    },
    phoneNumber: {
      required,
      numeric,
      minLength: minLength(10),
    },
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    password: {
      required,
      minLength: minLength(4),
      sameAsPassword: sameAs('repeatPassword'),
    },
  },

  mounted() {
    if (this.smsCodeValid !== true) {
      this.$router.push({ name: 'enter-number' });
    } else {
      this.handleLoadProfile();
    }
  },

  methods: {
    handleLoadProfile() {
      this.$http
        .post('/confirmation/get-profile', {
          phone_code: this.phoneCode,
          phone_number: this.phoneNumber,
          security_code: this.smsCode,
        })
        .then((response) => {
          switch (this.getResponceStatusCode(response)) {
            case responseCodes.RESPONSE_USER_PROFILE_FETCHED:
              this.firstName = _.get(response, 'data.first_name');
              this.lastName = _.get(response, 'data.last_name');
              this.password = '';
              this.repeatPassword = '';

              break;

            default:
              this.setResponseError(response.data.error_code);
          }
        })
        .catch((error) => {
          this.catchResponseError(error);
        });
    },

    handleRequestUrl() {
      return '/confirmation/update-profile';
    },

    handleRequestParams() {
      return {
        first_name: this.firstName,
        last_name: this.lastName,
        password: this.password,
        phone_code: this.phoneCode,
        phone_number: this.phoneNumber,
        security_code: this.smsCode,
      };
    },

    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        case responseCodes.RESPONSE_USER_PROFILE_UPDATED:
          this.$router.push({ name: 'enter-password' });
          break;

        default:
          this.setResponseError(response.data.error_code);
      }
    },
  },
};
</script>
